import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-798669b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (row, i) => {
    return (_openBlock(), _createElementBlock("div", {
      key: i,
      class: "result-raw"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, j) => {
        return (_openBlock(), _createElementBlock("img", {
          key: j,
          class: _normalizeClass(`result-cell ${ _ctx.rounded ? 'mi2' : ''}`),
          src: col,
          style: {"max-height":"50px","max-width":"100%"}
        }, null, 10 /* CLASS, PROPS */, _hoisted_1))
      }), 128 /* KEYED_FRAGMENT */))
    ]))
  }), 128 /* KEYED_FRAGMENT */))
}